import React, { useState } from 'react';
import Modal from './Modal';

const EvidenciaButton = ({ tareaId }) => {
  const [showModal, setShowModal] = useState(false);
  const [archivo, setArchivo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setArchivo(file);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!archivo) {
      setError('Por favor seleccione un archivo');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const formData = new FormData();
      formData.append('archivo', archivo);

      // Usar la misma estructura de URL que los otros servicios
      const API_BASE_URL = process.env.REACT_APP_API_URL;
      const url = `${API_BASE_URL}tareas/${tareaId}/evidencia`;
      console.log('URL de evidencia:', url);
      console.log('API_BASE_URL:', API_BASE_URL);
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          // NO incluir Content-Type, se establece automáticamente para FormData
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Error al subir evidencia');
      }

      const resultado = await response.json();
      setSuccess('Evidencia subida correctamente');
      setArchivo(null);
      
      // Limpiar el input de archivo
      const fileInput = document.getElementById('archivo-input');
      if (fileInput) {
        fileInput.value = '';
      }
      
      // Cerrar modal después de 2 segundos
      setTimeout(() => {
        setShowModal(false);
        setSuccess('');
      }, 2000);
      
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setArchivo(null);
    setError('');
    setSuccess('');
    // Limpiar el input de archivo
    const fileInput = document.getElementById('archivo-input');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  return (
    <>
      <button
        className="evidencia-btn"
        style={{
          padding: '4px 12px',
          fontSize: '14px',
          marginLeft: 6,
          backgroundColor: '#17a2b8',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
        onClick={() => setShowModal(true)}
      >
        Evidencia
      </button>

      {showModal && (
        <Modal
          title="Subir Evidencia"
          onClose={handleCloseModal}
          actions={
            <button
              onClick={handleCloseModal}
              style={{
                padding: '8px 16px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Cancelar
            </button>
          }
        >
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <h3>Tarea ID: {tareaId}</h3>
              <p>Seleccione el archivo de evidencia que desea subir</p>
            </div>

            {error && (
              <div style={{ color: 'red', marginBottom: '10px', padding: '10px', backgroundColor: '#ffe6e6', borderRadius: '4px' }}>
                {error}
              </div>
            )}

            {success && (
              <div style={{ color: 'green', marginBottom: '10px', padding: '10px', backgroundColor: '#e6ffe6', borderRadius: '4px' }}>
                {success}
              </div>
            )}

            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="archivo-input" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Seleccionar Archivo:
              </label>
              <input
                id="archivo-input"
                type="file"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '14px'
                }}
                required
              />
              <small style={{ color: '#666', fontSize: '12px' }}>
                Formatos permitidos: PDF, DOC, DOCX, JPG, JPEG, PNG, TXT
              </small>
            </div>

            <div style={{ textAlign: 'right' }}>
              <button
                type="submit"
                disabled={isLoading || !archivo}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: isLoading || !archivo ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  opacity: isLoading || !archivo ? 0.6 : 1
                }}
              >
                {isLoading ? 'Subiendo...' : 'Subir Evidencia'}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  );
};

export default EvidenciaButton;
